
// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {
	// var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		if (target.length > 0) {
			var position = target.offset().top - headerHeight;
			$("html, body").animate({ scrollTop: position }, 550, "swing");
			return false;
		}
	});
})


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
	if ($('.js-accordion-trigger').length > 0 && $('.js-accordion-target').length > 0) {
		$('.js-accordion-trigger').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$(e.target).next('.js-accordion-target').slideToggle();
			$(e.target).toggleClass("--close");
		});
	}
});


// ドロワーメニュー // Drawer menu
jQuery(function ($) {
	if ($('.c-hamburger').length > 0) {
		$('.c-hamburger').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			$(this).toggleClass('toggle_active');
			bg.fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				nav.addClass('is_open');
				nav.removeClass('is_close');
			} else {
				nav.removeClass('is_open');
				nav.addClass('is_close');
			}
		});

		$('.drawer_bg').click(function () {
			var parentHeader = $(this).closest('header');
			var nav = parentHeader.find('nav');
			var bg = $('.drawer_bg', parentHeader);

			bg.fadeOut();
			$('.c-hamburger').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			nav.removeClass('is_open');
			nav.addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function () {
			// if (window.innerWidth <= 768) {
			if ($('.c-hamburger:visible').length > 0) {
				$('.c-hamburger').click();
			}
		});
	}
});


// ヘッダーの固定エフェクト
jQuery(function ($) {
	const $header = $('header');
	$(window).scroll(function () {
		if ($(window).scrollTop() > 50) {
			$header.addClass('is-scrolling');
		} else {
			$header.removeClass('is-scrolling');
		}
	});
});

// Navigation
jQuery(function ($) {
	let set = window.innerWidth > 1000;
	$('.js-nav').hover(function () {
		if (set) {
			$(this).addClass('active');
			$(this).find('.l-nav__sub-menu').stop().fadeIn(300);
		}

	}, function () {
		if (set) {
			$(this).removeClass('active');
			$(this).find('.l-nav__sub-menu').stop().fadeOut(300);
		}
	});

	document.querySelectorAll('.js-nav__spTrigger').forEach(trigger => {
		if (trigger.nextElementSibling.classList.contains('js-nav__spTarget')) {
			trigger.addEventListener('click', function (e) {
				if (!set) {
					e.preventDefault();
					e.stopPropagation();
					const trgr = e.target.closest('.js-nav__spTrigger');
					const wrapper = trgr.closest('.js-nav')
					const target = wrapper.querySelector('.js-nav__spTarget');

					if (wrapper.classList.contains('active')) {
						wrapper.classList.remove('active');
						jQuery(target).stop().slideUp();
					} else {
						wrapper.classList.add('active');
						jQuery(target).stop().slideDown();
					}
				}


			}, false);
		}
	});

	window.addEventListener('resize', function (e) {
		set = window.innerWidth > 1000;
	});
});

document.addEventListener('DOMContentLoaded', function (event) {
	// --- TOPタブ切り替え
	if (document.querySelector('.js-newsSwitch .js-newsSwitch__trigger') && document.querySelector('.js-newsSwitch .js-newsSwitch__target')) {
		document.querySelectorAll('.js-newsSwitch .js-newsSwitch__trigger').forEach(button => {
			if (button.dataset.category && button.closest('.js-newsSwitch').querySelector(`.js-newsSwitch__target[data-category="${button.dataset.category}"]`)) {
				button.addEventListener('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					const trigger = e.target.closest('.js-newsSwitch__trigger');
					const wrapper = trigger.closest('.js-newsSwitch');
					const target = wrapper.querySelector(`.js-newsSwitch__target[data-category="${trigger.dataset.category}"]`);

					wrapper.querySelector('.js-newsSwitch__trigger.current').classList.remove('current');
					wrapper.querySelector('.js-newsSwitch__target.current').classList.remove('current');

					trigger.classList.add('current');
					target.classList.add('current');

				}, false);
			} else {
				console.error('お知らせのタブ切り替えに不備があります');
			}

		})
	}
});